"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getInvoicePdf = getInvoicePdf;
exports.getInvoices = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var getInvoices = exports.getInvoices = function getInvoices(contractId) {
  var cancelToken = _axios.default.CancelToken;
  var source = cancelToken.source();
  var config = {
    cancelToken: source.token
  };
  var response = _CacheHandler.default.requestCache(function () {
    var baseURL = _RestHelper.default.getBaseUrl();
    return _RestHelper.default.get("".concat(baseURL, "/cscn-customer-srv/api/partner/v0/invoices?contractAccountId=").concat(contractId), {}, config);
  }, "invoices_".concat(contractId));
  return new Promise(function (resolve, reject) {
    response.then(function (responseData) {
      resolve(responseData);
    }).catch(function (err) {
      var error = err;
      if (_axios.default.isCancel(error)) {
        error.type = 'cancel';
      }
      reject(error);
    });
  });
};
function getInvoicePdf(invoiceId, contractAccountId) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/invoices/").concat(invoiceId, "?contractAccountId=").concat(contractAccountId), {}, {
    responseType: 'blob'
  });
}
var _default = exports.default = {
  getInvoices: getInvoices,
  getInvoicePdf: getInvoicePdf
};